export default function useIsHasClothInPrize(prize = {}) {
  for (const key in prize) if (key.startsWith('shopItem') && !!prize[key]) return true;
}
